import { Box, DialogContent, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { mobileTypography } from 'src/config/theme';

import { AvatarIcon, HeaderPart, FooterPart } from './Patients/Forms/Style';
import ButtonComponent from 'src/components/shared/Button';
import DialogBox from 'src/components/shared/Dialog/DialogBox';
import { ReactComponent as CloseIcon } from '../../../../src/assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../src/assets/images/add-square.svg';
import { ReactComponent as Danger } from '../../../../src/assets/images/danger.svg';
import useResponsive from 'src/components/hooks/useResponsive';


const DeleteDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Delete',
  message = 'Are you sure you want to delete this item?',
  confirmText = 'Delete',
  idToDelete,
  subtitle,
  onCancel
}) => {
  const theme = useTheme();
  const palette = theme.palette;
  const shadows = theme.shadows;
  const { isMobile, isTablet, isDesktop } = useResponsive();
  const Width = isMobile || isTablet ? '20px' : '24px';
  const Height = isMobile || isTablet ? '20px' : '24px';

  return (
    <DialogBox open={open} onClose={onClose}>
      <HeaderPart>
        {title}
        <CloseIcon width={isMobile || isTablet ? 18 : 24}
          height={isMobile || isTablet ? 18 : 24} onClick={onClose} style={{ cursor: 'pointer' }} />
      </HeaderPart>
      <DialogContent dividers>
        <Box sx={{ width: isMobile || isTablet ? '100%' : '470px', height: '314px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Box sx={{ width: '232px', height: '186px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <AvatarIcon sx={{ bgcolor: "transparent" }}>
              <Danger width="24px" height="24px" />
            </AvatarIcon>
            <Typography variant="h5">{title}</Typography>
            <Typography sx={{ ...theme.typography.smallRegular, color: alpha(palette.gery.black, 0.7), textAlign: 'center', marginTop: '10px' }}>
              {message}
            </Typography>
            <Typography sx={{ ...theme.typography.smallRegular, color: theme.palette.gery.black, marginTop: '5px' }}>
              {subtitle}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <FooterPart>
        <ButtonComponent
          variant="none"
          startIcon={<CloseIcon width={isMobile || isTablet ? 18 : 24}
            height={isMobile || isTablet ? 18 : 24} sx={{ color: palette.primary.main }} />}

          onClick={() => {
            onClose();
            if (typeof onCancel === 'function') {
              onCancel();
            }
          }}
        >
          Cancel
        </ButtonComponent>
        <ButtonComponent
          variant="outlined"
          startIcon={<AddIcon width={Width} height={Height} sx={{ color: palette.primary.main }} />}
          sx={{
            width: '104px',
            height: '52px',
            borderRadius: '12px',
            padding: '10px 18px',
            bgcolor: palette.primary.main,
            boxShadow: shadows[1],
            border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
            color: palette.gery.white,
            '&:hover': { color: palette.primary.main },
            [theme.breakpoints.down('md')]: {
              ...(theme?.mobileTypography?.h6 || mobileTypography.h6),
              width: '78px',
              height: '40px',
              borderRadius: '8px',
              padding: '10px 12px'
            }
          }}
          onClick={() => onConfirm(idToDelete)}
        >
          {confirmText}
        </ButtonComponent>
      </FooterPart>
    </DialogBox>
  );
};

export default DeleteDialog;
